import {
  Filter, CustomFilterType, FilterType, FilterCommonValues, PredefinedIds,
  PredefinedFilterType, PredefinedFilter
} from 'app/area/search-filters/filters/types';
import { CodetableTranslation } from 'app/area/codetable/constants';
import { endpoints } from 'app/area/codetable/list/endpoints';
import { allPredefinedFilters, filterId, fieldType } from 'app/area/search-filters/constants';
import { filterCategoryLabel, shouldShowFilter, shouldShowPredefinedFilter } from 'app/area/codetable/list/search-filters/configuration-helpers';
import { CodetableMetadata, CodetableScreenName } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { codeFilterIds } from 'app/area/codetable/list/search-filters/constants';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';

export const codeQueryFilters = (translation): CodeComplexValue<string>[] => undefined;

export const codePredefinedFilters = (translation: CodetableTranslation, metadata: CodetableMetadata): PredefinedFilter => ({
  type: PredefinedFilterType.code,
  values: [
    { value: allPredefinedFilters.excludeInactiveCodes, description: translation.hide_inactive_codes_filter }
  ].filter(shouldShowPredefinedFilter(metadata)) || undefined
});

export const codeFilters = (codetableId: number, translation: CodetableTranslation, metadata: CodetableMetadata): Filter[] => [
  {
    id: filterId.userGroup,
    label: metadata?.formName === CodetableScreenName.UserGroup
      ? translation.available_for_current_user_group
      : translation.visible_for_user_groups,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.codeWithoutExclude,
        optionsEndpoint: endpoints.optionsCollectionAll(codeFilterIds.userGroup),
        optionsParams: { displayNotSelected: true }
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.caseType,
    label: translation.visible_for_case_types,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.codeWithoutExclude,
        optionsEndpoint: endpoints.caseType(),
        optionsParams: { optionsCollectionId: codetableId, displayNotSelected: true }
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.type,
    label: translation.types,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.codeWithoutExclude,
        optionsEndpoint: endpoints.optionsCollectionAll(metadata?.codetableClass?.id),
        optionsParams: { displayNotSelected: true },
        isHierarchy: false
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.category,
    label: filterCategoryLabel(codetableId, translation, metadata),
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.codeWithoutExclude,
        optionsEndpoint: endpoints.optionsCollectionAll(metadata?.codetableCategory?.id),
        optionsParams: { displayNotSelected: true },
        isHierarchy: false
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.fields,
    label: translation.visible_for_fields,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.codeWithoutExclude,
        optionsEndpoint: endpoints.visibleForFields(),
        optionsParams: { displayNotSelected: true, optionsCollectionId: codetableId }
      }
    ],
    type: FilterType.SELECTED_IDS
  },
  {
    id: filterId.code,
    label: translation.code,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.inputIntegerWithoutExclude,
        includeInSummary: true
      }
    ],
    type: FilterType.TEXT_RANGE
  },
  {
    id: filterId.measurementSystem,
    label: translation.uom_measurement_system,
    fields: [
      {
        fieldTypeId: fieldType.root,
        type: CustomFilterType.codeWithoutExclude,
        optionsEndpoint: endpoints.optionsCollectionAll(codetableOptionsIds.measurementSystem),
        optionsParams: { displayNotSelected: true },
        isHierarchy: false
      }
    ],
    type: FilterType.SELECTED_IDS
  }
].filter(shouldShowFilter(metadata)) || [];

export const codeDefaultFilters = (
  translation: CodetableTranslation,
  metadata: CodetableMetadata
): { [key: string]: FilterCommonValues<number>[] } => ({
  [PredefinedIds.include]: [
    { value: allPredefinedFilters.excludeInactiveCodes, description: translation.hide_inactive_codes_filter }
  ].filter(shouldShowPredefinedFilter(metadata))
});
